import type { IntegrationFilterValue } from '@/mocks/saIntegrations';

interface IntegrationFiltersProps {
  activeFilter: IntegrationFilterValue;
  onFilterChange: (filter: IntegrationFilterValue) => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  viewMode: 'grid' | 'list';
  onViewModeChange: (mode: 'grid' | 'list') => void;
  counts: { all: number; connected: number; disconnected: number; error: number; pending: number };
}

const filters: { value: IntegrationFilterValue; label: string; icon: string }[] = [
  { value: 'all', label: 'Todas', icon: 'ri-apps-line' },
  { value: 'connected', label: 'Conectadas', icon: 'ri-checkbox-circle-line' },
  { value: 'disconnected', label: 'Desconectadas', icon: 'ri-close-circle-line' },
  { value: 'error', label: 'Con errores', icon: 'ri-error-warning-line' },
  { value: 'pending', label: 'Pendientes', icon: 'ri-time-line' },
];

export default function IntegrationFilters({ activeFilter, onFilterChange, searchQuery, onSearchChange, viewMode, onViewModeChange, counts }: IntegrationFiltersProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      {/* Search */}
      <div className="relative w-full sm:w-auto sm:min-w-[280px]">
        <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-300 text-sm"></i>
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Buscar integración..."
          className="w-full pl-9 pr-4 py-2 rounded-xl border border-background-200 bg-background-50 text-foreground-700 text-sm placeholder:text-foreground-300 focus:outline-none focus:border-primary-300 transition-colors"
        />
      </div>

      {/* Filter pills */}
      <div className="flex items-center gap-1.5 flex-wrap">
        {filters.map((f) => (
          <button
            key={f.value}
            onClick={() => onFilterChange(f.value)}
            className={`inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-[10px] font-bold cursor-pointer whitespace-nowrap transition-colors ${
              activeFilter === f.value
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-500 hover:bg-background-200'
            }`}
          >
            <i className={`${f.icon} text-[10px]`}></i>
            {f.label}
            <span className={`ml-0.5 px-1 py-0.5 rounded-full text-[8px] ${activeFilter === f.value ? 'bg-white/20 text-background-50' : 'bg-background-200 text-foreground-400'}`}>
              {counts[f.value]}
            </span>
          </button>
        ))}

        {/* View toggle */}
        <div className="ml-2 flex items-center bg-background-100 rounded-lg p-0.5">
          <button
            onClick={() => onViewModeChange('grid')}
            className={`px-2 py-1.5 rounded-md cursor-pointer transition-colors ${viewMode === 'grid' ? 'bg-background-50 text-foreground-800 shadow-sm' : 'text-foreground-400 hover:text-foreground-600'}`}
          >
            <i className="ri-layout-grid-line text-xs"></i>
          </button>
          <button
            onClick={() => onViewModeChange('list')}
            className={`px-2 py-1.5 rounded-md cursor-pointer transition-colors ${viewMode === 'list' ? 'bg-background-50 text-foreground-800 shadow-sm' : 'text-foreground-400 hover:text-foreground-600'}`}
          >
            <i className="ri-list-check text-xs"></i>
          </button>
        </div>
      </div>
    </div>
  );
}